export default () => {

  const t = {};
  const init = () => {
    t.formContent = document.querySelector('.ct-body__contact');
    if (!t.formContent) {
      return;
    }

    if (isExcursion()) {
      translateTabPosition();
    }
  }

  const isExcursion = () => {
    const referrerUrlObj = new URL(document.referrer);
    return /^\/contact/.test(referrerUrlObj.pathname)
  }
  const translateTabPosition = () => {
    const pageScrollQuantity = window.scrollY || window.pageYOffset;
    const windowFrameOffsetY = t.formContent.getBoundingClientRect().y;
    window.scrollTo(0, pageScrollQuantity + windowFrameOffsetY);
  }

  init();
}
